import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useLocation, useRouteMatch } from 'react-router-dom'
import { DesignContext } from 'contexts/DesignContext'
import objectPath from 'object-path'
import { Modal } from 'react-bootstrap'
import Swal from 'sweetalert2'
import styles from 'designer/styles/modal.module.css'
import Component from './index'

import {
  getElementAction,
  updateCondition,
} from 'designer/component/action/Condition'
import { getForm, getPage } from 'designer/component/action/Design'
import {
  compareTwoValue,
  generateString,
  getCurrentUi,
  setRequestFormData,
  updateFormDataValue,
} from '../action/Data'
import { isNumber } from '../action/Data'
import PatientAssessment from './PatientAssessment'
import cloneDeep from 'clone-deep'
import { onCheckCondition } from '../action/condition/Action'
import { checkPropTab, getApi } from '../action/Api'
import httpClient from 'utility/httpClient.util'
import { debounceCallback } from 'utility/debounceCallback.util'
import Title from '../container/title/Title'
import { onTriggerModal } from '../element/button/Modal'
import { getFormGroup } from '../action/FormGroup'
import {
  findModalSendProp,
  getFirstDefinedValue,
  getModalSendProps,
  runModalReceiveRules,
  updateModalReceiveFormDataBySystem,
  updateModalReceiveFilesFormData,
} from './modalReceiveData.util'

const NormalModal = ({
  children,
  isOpenModal,
  closeExternalModal,
  ui,
  modalAction,
}) => {
  const modalSize = modalAction?.modalSize || ui?.modalSize || 'xl'
  const cardColor = modalAction?.cardColor || ui.cardColor
  const textColor = modalAction?.textColor || ui.textColor
  const fontSize = modalAction?.fontSize || ui.fontWeight || '18px'
  const fontWeight = modalAction?.fontWeight || ui.fontWeight || 'bold'
  const title = modalAction?.title || ui.title
  const closeButton = modalAction?.closeButton
  let props = {
    uischema: { ...modalAction, ...ui, fontWeight, fontSize },
    isModalTitle: true,
    isActive: false,
    modalTitle: title,
  }

  return (
    <Modal show={isOpenModal} size={modalSize}>
      <Modal.Header
        closeButton={closeButton === undefined ? true : closeButton}
        onHide={closeExternalModal}
        style={{
          backgroundColor: cardColor || '#fff',
        }}
      >
        <h5
          className="mb-0"
          style={{
            color: textColor || '#000',
          }}
        >
          <Title {...props} />
        </h5>
      </Modal.Header>
      <Modal.Body className="p-0">{children}</Modal.Body>
    </Modal>
  )
}

const FullSizeModal = ({
  children,
  isOpenModal,
  closeExternalModal,
  ui,
  modalAction,
}) => {
  const cardColor = modalAction?.cardColor || ui.cardColor
  const textColor = modalAction?.textColor || ui.textColor
  const fontSize = modalAction?.fontSize || ui.fontWeight || '18px'
  const fontWeight = modalAction?.fontWeight || ui.fontWeight || 'bold'
  const title = modalAction?.title || ui.title
  const closeButton = modalAction?.closeButton
  let props = {
    uischema: { ...modalAction, ...ui, fontWeight, fontSize },
    isModalTitle: true,
    isActive: false,
    modalTitle: title,
  }

  return (
    <Modal
      fullscreen="true"
      dialogClassName={styles.modalFullScreen}
      className="pl-0"
      show={isOpenModal}
    >
      <Modal.Header
        closeButton={closeButton === undefined ? true : closeButton}
        onHide={closeExternalModal}
        style={{
          backgroundColor: cardColor || '#fff',
        }}
      >
        <h5
          className="mb-0"
          style={{
            color: textColor || '#000',
          }}
        >
          <Title {...props} />
        </h5>
      </Modal.Header>
      <Modal.Body className="p-0">{children}</Modal.Body>
    </Modal>
  )
}

const ModalButton = (props) => {
  const {
    ui,
    modalAction,
    isOpenModal = false,
    onRefreshTable,
    designerPropsData = {},
    modalDynamicIndex = null,
    isModalCondition,
    closeModalCondition,
    uiModalCode,
    dynamicData,
    dynamicKey,
    config = {},
  } = props

  const designContext = useContext(DesignContext)
  const datasourceValue = objectPath.get(designContext, `@datasource`) || {}

  const {
    isPage,
    jsonForm,
    setDesignerPropsData,
    setComponentPropsData,
    openModal,
    setOpenModal,
    setModalComponent,
    setSchema,
    setFormData,
    searchData,
    setSearchData,
    showInvisible,
    setIsInitialOption,
    tabParamActive,
    setOpenModalCondition,
    isUiChanged,
    setIsUiChanged,
    setIsLoadingApi,
    widgetDesign,
  } = designContext

  const modalId = objectPath.get(modalAction, 'formId')
  const componentKey = ui.key
  const checkDup = ui.checkDup
  const checkDupKey = ui.checkDupKey
  const alertMessage = ui.alertMessage
  const modalSize = modalAction?.modalSize || ui?.modalSize || 'xl'
  const modalType = modalAction?.modalType || ''
  const sourceType =
    modalAction?.sourceType ||
    objectPath.get(jsonForm, 'designerPropsData.sourceType') ||
    ''
  const modalKey = ui.key
  const triggerModal = objectPath.get(isUiChanged, 'triggerModal') || {}
  const modalCode = triggerModal[modalKey]
  const modalData = modalCode
    ? objectPath.get(isUiChanged, ['modal', modalCode])
    : null
  const isOpening = modalData?.isOpening
  const { isFormComponent, formComponent } = config
  const formComponentName = formComponent?.name

  const match = useRouteMatch()
  const location = useLocation()
  const search = location.search || []
  const receivePathParams = match.params
  const urlSearchParams = new URLSearchParams(search)
  const receiveQueryParams = Object.fromEntries([...urlSearchParams])
  const allParams = { ...receivePathParams, ...receiveQueryParams }

  const [modal, setModal] = useState({})

  const closeExternalModal = (componentPropsData = {}, receiveProps = []) => {
    setIsLoadingApi('done')
    if (isModalCondition) {
      if (
        !modalCode ||
        !uiModalCode ||
        (modalCode && uiModalCode && modalCode !== uiModalCode)
      )
        return
    } else {
      if (!modalCode) return
    }
    let conditions = objectPath.get(jsonForm, 'conditions')
    let formData = objectPath.get(jsonForm, 'formData') || {}
    let newSearchData = { ...searchData, ...formData }
    let elementAction = getElementAction(designContext, conditions, jsonForm)
    let tagname = ui.tagname
    let isDynamic = tagname === 'dynamic'

    let { isRefreshTable = false } = componentPropsData

    if (objectPath.get(formData, '@condition') === undefined) {
      objectPath.set(formData, `@condition`, {})
    }
    objectPath.set(formData, `@condition.${modalId}`, {})

    objectPath.set(designerPropsData, 'modal', null)
    setDesignerPropsData(designerPropsData)
    setOpenModal(null)
    let modalCondition = cloneDeep(modal?.ui?.jsonForm?.conditions)

    setModal({})

    let actionUpdate = objectPath.get(elementAction, ['actionUpdate'])
    if (actionUpdate) {
      actionUpdate.forEach(async (key) => {
        formData = await updateCondition(
          showInvisible,
          formData,
          key,
          designContext,
        )
        if (isPage === 1) {
          newSearchData = await updateCondition(
            showInvisible,
            newSearchData,
            key,
            designContext,
          )
        }
      })
    }
    let designerData = objectPath.get(jsonForm, 'designerPropsData.data') || {}
    let componentData = objectPath.get(componentPropsData, 'data') || {}
    let data = { ...designerData, ...componentData }
    let formGroup = getFormGroup(designContext)

    if (componentPropsData.receive) {
      receiveProps = componentPropsData.receive || []
    }
    let sendProps = getModalSendProps(componentPropsData.send)
    let filterReceive
    if (sendProps && sendProps.length > 0) {
      filterReceive = receiveProps.filter((receive) => {
        let found = findModalSendProp(sendProps, receive)
        return found ? true : false
      })
    } else {
      filterReceive = receiveProps
    }
    filterReceive.forEach((itemReceive) => {
      let {
        prop,
        system = [],
        systemType,
        propKey,
        jsonKey,
        fullPropKey,
        systemName,
        systemKey,
        isDynamic,
        propType,
      } = itemReceive
      let label, name
      let value
      let foundSend =
        sendProps && findModalSendProp(sendProps, itemReceive)
      if (itemReceive.propType === 'custom') {
        if (foundSend) {
          value = foundSend.value
        }
      } else {
        value = getFirstDefinedValue(data, [
          foundSend?.value,
          fullPropKey ? `@sendData.${fullPropKey}` : '',
          fullPropKey,
          jsonKey ? `@sendData.${jsonKey}` : '',
          jsonKey,
          propKey ? `@sendData.${propKey}` : '',
          propKey,
          prop ? `@sendData.${prop}` : '',
          prop,
        ])
      }
      if (systemName) {
        let nameSplit = systemName.split(' | ')
        label = objectPath.get(nameSplit, 0)
        name = objectPath.get(nameSplit, 1)
      }
      if (name && formComponentName) {
        name = `${formComponentName}.${name}`
      }
      if (isDynamic) {
        system.forEach(({ field, systemKey, systemName, dynamicName }) => {
          let value = objectPath.get(data, field)
          if (dynamicName && formComponentName) {
            dynamicName = `${formComponentName}.${dynamicName}`
          }
          objectPath.set(formData, [dynamicName, systemKey], value)
          if (isPage === 1) {
            objectPath.set(newSearchData, [dynamicName, systemKey], value)
          }
        })
      } else if (systemType === 'tableWaitUpsert') {
        let dataTable = objectPath.get(formData, systemKey) || []
        let rowData = objectPath.get(data, prop)
        objectPath.set(isUiChanged, 'isWaitUpsert', {
          status: true,
          key: systemKey,
          table: dataTable,
          rowData: rowData,
          isModalProp: true,
          isReplace: false,
        })
      } else if (systemType === 'tableConfirmUpsert') {
        let dataTable = objectPath.get(componentData, fullPropKey) || []
        objectPath.set(formData, systemKey, dataTable)
      } else if (systemType === 'addToTable') {
        let currentTable = objectPath.get(formData, systemKey) || []
        let comingTable = value
        let replaceTable = itemReceive?.dataTable
        if (replaceTable && comingTable) {
          comingTable.map((coming) => {
            replaceTable.forEach((replace) => {
              let hasValue = objectPath.has(coming, replace.response)
              if (hasValue) {
                let value = objectPath.get(coming, replace.response)
                objectPath.set(coming, replace.value, value)
              }
            })
            return coming
          })
        }

        let columnFilter = itemReceive?.columnFilter
        if (columnFilter && comingTable) {
          comingTable = comingTable.filter((coming) => {
            let foundFilter = columnFilter.every((item) => {
              let { compareType, filterValue } = item
              let rowValue = objectPath.get(coming, item.value)
              return compareTwoValue(compareType, rowValue, filterValue)
            })
            return foundFilter
          })
        }
        let newTable = currentTable.concat(comingTable)
        let filterTable = newTable
          .filter((item) => {
            objectPath.del(item, '@genId')
            objectPath.del(item, '@seq')
            objectPath.del(item, 'tableData')
            let length = Object.keys(item).length
            return length > 0
          })
          .map((item, index) => ({
            ...item,
            '@seq': index + 1,
          }))
        system.forEach(({ systemKey, dynamicName }) => {
          if (dynamicName && formComponentName) {
            dynamicName = `${formComponentName}.${dynamicName}`
          }
          objectPath.set(formData, systemKey, filterTable)
          objectPath.set(formData, dynamicName, filterTable)
          objectPath.set(isUiChanged, `${systemKey}.isRender`, true)
        })
      } else if (systemType === 'replaceRow') {
        let currentTable = objectPath.get(formData, system) || []
        let currentData =
          objectPath.get(designerData, [systemKey, itemReceive.fullPropKey]) ||
          []
        let currentIndex = currentTable.findIndex(
          (item) => item?.tableData?.no === currentData?.tableData?.no,
        )
        if (currentIndex > -1) {
          currentTable[currentIndex] = { ...currentData, ...value }
        }
        if (system && formComponentName) {
          system = `${formComponentName}.${system}`
        }
        objectPath.set(formData, systemKey, currentTable)
        objectPath.set(formData, system, currentTable)
      } else if (systemType === 'rowWaitReplace') {
        let currentTable = cloneDeep(objectPath.get(formData, systemKey)) || []
        let rowData = cloneDeep(objectPath.get(data, prop))
        let rowEdit = objectPath.get(isUiChanged, '@rowEdit')
        let replaceTable = []
        currentTable.forEach((item) => {
          if (item.tableData.no === rowEdit.tableData.no) {
            objectPath.del(rowData, 'tableData')
            item = {
              ...item,
              ...rowData,
            }
          }
          replaceTable.push(item)
        })
        objectPath.set(isUiChanged, 'isWaitUpsert', {
          status: true,
          key: systemKey,
          table: replaceTable,
          rowData: [rowData],
          isModalProp: true,
          isReplace: true,
        })
      } else if (systemType === 'rowConfirmReplace') {
      } else if (systemType === 'table') {
        if (propType === 'formData') {
          let currentTable = objectPath.get(formData, ui.key) || []
          let rowTableValue = objectPath.get(data, fullPropKey)
          let columnRefId = ui?.loadData?.columnRefId

          if (columnRefId) {
            let id = objectPath.get(rowTableValue, columnRefId)
            let genId = objectPath.get(rowTableValue, '@genId')
            if (id || genId) {
              let foundIndex = currentTable.findIndex(
                (item) =>
                  objectPath.get(item, columnRefId) === id ||
                  objectPath.get(item, '@genId') === genId,
              )
              if (foundIndex > -1) {
                objectPath.set(currentTable, foundIndex, rowTableValue)
              }
            } else {
              let genId = generateString(10)
              objectPath.set(rowTableValue, '@genId', genId)
              currentTable.push(rowTableValue)
            }
            let name = ui.name
            if (name && formComponentName) {
              systemName = `${formComponentName}.${name}`
            }
            objectPath.set(formData, name, currentTable)
            objectPath.set(formData, ui.key, currentTable)
          }
        } else {
          let tableValue = objectPath.get(data, `${systemKey}.${prop}`)
          objectPath.set(formData, prop, tableValue)
        }
      } else if (systemType === 'input') {
        objectPath.set(formData, systemKey, value)
        if (name) {
          objectPath.set(formData, name, value)
        }
        if (isPage === 1) {
          objectPath.set(newSearchData, systemKey, value)
          if (name) {
            objectPath.set(newSearchData, name, value)
          }
        }
      } else if (systemType === 'groupInput') {
        system.forEach(({ field, systemKey, systemName }) => {
          if (systemName && formComponentName) {
            systemName = `${formComponentName}.${systemName}`
          }
          let value = objectPath.get(data, field)
          objectPath.set(formData, systemKey, value)
          objectPath.set(formData, systemName, value)
          if (isPage === 1) {
            objectPath.set(newSearchData, systemKey, value)
            objectPath.set(newSearchData, systemName, value)
          }
        })
      } else if (systemType === 'formData') {
        let source = getFirstDefinedValue(data, [
          propKey ? `@sendData.${propKey}` : '',
          propKey,
          prop ? `@sendData.${prop}` : '',
          prop,
        ])
        if (system && system.length > 0) {
          let result = updateModalReceiveFormDataBySystem({
            formData,
            newSearchData,
            data,
            source,
            prop,
            system,
            formComponentName,
            isPage,
          })
          formData = result.formData
          newSearchData = result.newSearchData
        } else {
          formData = updateFormDataValue({
            jsonForm,
            formGroup: formGroup,
            formDataName: systemName,
            formDataKey: systemKey,
            source: source,
            destination: formData,
            type: 'prop',
            isRequired: false,
          })
          if (isPage === 1) {
            newSearchData = updateFormDataValue({
              jsonForm,
              formGroup: formGroup,
              formDataName: systemName,
              formDataKey: systemKey,
              source: source,
              destination: formData,
              type: 'prop',
              isRequired: false,
            })
          }
        }
      } else if (systemType === 'widget') {
        let source = getFirstDefinedValue(data, [
          propKey ? `@sendData.${propKey}` : '',
          propKey,
          prop ? `@sendData.${prop}` : '',
          prop,
        ])
        if (systemName && formComponentName) {
          systemName = `${formComponentName}.${systemName}`
        }
        objectPath.set(formData, systemKey, source)
        objectPath.set(formData, systemName, source)
      } else if (systemType === 'condition') {
        let conditionValue = 1
        objectPath.set(
          formData,
          `@condition.${modalId}.${fullPropKey}`,
          conditionValue,
        )
        if (isPage === 1) {
          objectPath.set(
            newSearchData,
            `@condition.${modalId}.${fullPropKey}`,
            conditionValue,
          )
          objectPath.set(
            formData,
            `@condition.${modalId}.${fullPropKey}`,
            conditionValue,
          )
        }
      } else if (systemType === 'dynamic') {
        let data = objectPath.get(componentPropsData, 'data')
        let value = objectPath.get(data, prop)
        if (name && formComponentName) {
          name = `${formComponentName}.${name}`
        }
        if (value) {
          if (modalDynamicIndex > -1) {
            objectPath.set(formData, [systemKey, modalDynamicIndex], value)
            objectPath.set(formData, [name, modalDynamicIndex], value)
            if (isPage === 1) {
              objectPath.set(
                newSearchData,
                [systemKey, modalDynamicIndex],
                value,
              )
              objectPath.set(newSearchData, [name, modalDynamicIndex], value)
            }
          } else {
            let isPassDup = true
            if (checkDup) {
              let currentData = objectPath.get(formData, name)
              let foundData = currentData.find((item) => {
                return (
                  objectPath.get(item, checkDupKey) ===
                  objectPath.get(value, checkDupKey)
                )
              })
              if (foundData) {
                isPassDup = false
                Swal.fire({
                  icon: 'error',
                  title: alertMessage || 'พบรายการซ้ำ',
                  text: 'กรุณาลองใหม่อีกครั้ง',
                  confirmButtonText: 'ปิด',
                })
              }
            }
            if (isPassDup) {
              if (name) {
                objectPath.push(formData, name, value)
              } else {
                objectPath.push(formData, systemKey, value)
              }
              if (isPage === 1) {
                if (name) {
                  objectPath.push(newSearchData, name, value)
                } else {
                  objectPath.push(newSearchData, systemKey, value)
                }
              }
            }
          }
        }
      } else if (systemType === 'buttonAction') {
        objectPath.set(isUiChanged, itemReceive.elementKey, { doAction: true })
      } else if (systemType === 'files') {
        let result = updateModalReceiveFilesFormData({
          formData,
          newSearchData,
          data,
          prop,
          propKey,
          fullPropKey,
          systemKey,
          formComponentName,
          isPage,
        })
        formData = result.formData
        newSearchData = result.newSearchData
      } else if (systemType === 'addFiles') {
        let oldFiles = objectPath.get(formData, systemKey) || []
        let newFiles = objectPath.get(data, propKey)
        let concatFiles = newFiles.concat(oldFiles)
        objectPath.set(formData, systemKey, concatFiles)
        objectPath.set(formData, name, concatFiles)
      } else {
        let value = objectPath.get(data, prop)
        if (prop && formComponentName) {
          prop = `${formComponentName}.${prop}`
        }
        objectPath.set(formData, prop, value)
        if (isPage === 1) {
          objectPath.set(newSearchData, prop, value)
        }
      }
    })
    if (sendProps) {
      sendProps.forEach(({ prop, propType, source }) => {
        if (propType === 'condition') {
          let conditionValue = 1
          objectPath.set(
            formData,
            `@condition.${modalId}.${prop}`,
            conditionValue,
          )
          if (isPage === 1) {
            objectPath.set(
              newSearchData,
              `@condition.${modalId}.${prop}`,
              conditionValue,
            )
            objectPath.set(
              formData,
              `@condition.${modalId}.${prop}`,
              conditionValue,
            )
          }
        }
      })
    }
    onCheckCondition(designContext, formData, null, {
      isCloseModal: true,
      isModalCondition: isModalCondition,
      modalId: ui?.action?.formId,
      modalCondition: modalCondition,
    })
    formData = runModalReceiveRules({
      designContext,
      formData,
      receiveProps: filterReceive,
      formComponentName,
      status: {
        modalId: ui?.action?.formId,
        modalCondition: modalCondition,
        isModalCondition: isModalCondition,
      },
    })
    // objectPath.set(formData, '@condition', {})

    setFormData(formData)
    if (isPage === 1) {
      setSearchData(newSearchData)
    }
    if (isModalCondition) {
      closeModalCondition()
    }
    setIsInitialOption(-1)
    objectPath.del(isUiChanged, 'fetchSearch')
    objectPath.del(isUiChanged, 'tableSelection')
    objectPath.set(isUiChanged, 'isRefreshTable', true)

    if (isOpening) {
      onTriggerModal({ modalKey, designContext, isOpening: !isOpening })
    }
    setIsUiChanged(isUiChanged)
    if (isRefreshTable) {
      if (onRefreshTable) {
        onRefreshTable()
      } else {
        setComponentPropsData({ isRefreshTable: isRefreshTable })
      }
    }
  }

  const onCancelAssessment = () => {
    setOpenModal(null)
    setModal({})
  }

  useEffect(() => {
    let isActive = true
    const loadModal = async () => {
      if (!modalData) return
      if (modalData.isOpening) return
      let design = {}
      if (isModalCondition) {
        if (!uiModalCode) return setModal({})
        if (sourceType === 'form') {
          design = await getForm(uiModalCode)
        } else if (sourceType === 'page') {
          design = await getPage(uiModalCode)
        }
      } else {
        if (!modalCode) return setModal({})
        if (sourceType === 'form') {
          design = await getForm(modalCode)
        } else if (sourceType === 'page') {
          design = await getPage(modalCode)
        }
      }
      if (!isActive) return
      let designJsonForm = design.jsonForm
      if (designJsonForm) {
        objectPath.set(designJsonForm, 'componentPropsData', {})
        let modalMapFormData =
          objectPath.get(designJsonForm, 'schema.mapFormData') || {}
        let modalMapName = objectPath.get(designJsonForm, 'schema.mapName') || {}
        let modalMapField =
          objectPath.get(designJsonForm, 'schema.mapField') || {}
        let modalMapTag = objectPath.get(designJsonForm, 'schema.mapTag') || {}
        let filterModalFormData = Object.keys(modalMapFormData).filter(
          (key) => modalMapFormData[key],
        )
        let schema = jsonForm.schema
        objectPath.set(schema, 'mapModal', {})
        filterModalFormData.forEach((key) => {
          let name = modalMapName[key].split('.').pop()
          objectPath.set(schema, `mapModal.name.${key}`, `modal.${name}`)
          objectPath.set(schema, `mapModal.field.${key}`, modalMapField[key])
          objectPath.set(schema, `mapModal.tag.${key}`, modalMapTag[key])
        })
        setSchema(schema)

        let modal = cloneDeep(ui)
        objectPath.set(modal, 'ui.close', false)
        objectPath.set(modal, 'ui.formDesign', design.formDesign)

        let designerProps = objectPath.get(designerPropsData, 'props') || []
        let receiveProps = objectPath.get(modalAction, 'props') || []
        let designerData = objectPath.get(designerPropsData, 'data')
        let allFormGroup = jsonForm.formGroup
        receiveProps =
          typeof receiveProps === 'object'
            ? Object.values(receiveProps)
            : receiveProps

        let systemData = {}
        receiveProps.map(async (item) => {
          if (!item.propReceive) return
          let value
          let systemKey = item?.systemKey || ''
          let foundDesignerProp = designerProps.find(
            ({ key }) => systemKey === key,
          )
          if (foundDesignerProp) {
            item.system = foundDesignerProp.system
          }
          if (item.systemType === 'tab') {
            let [containerKey, paramName] = systemKey.split('.')
            value = checkPropTab({ designContext }, { containerKey, paramName })
            objectPath.set(systemData, item.fullPropKey, value)
          } else if (item.systemType === 'dynamic') {
            if (dynamicKey === systemKey) {
              if (item.jsonKey) {
                value = objectPath.get(
                  dynamicData,
                  `${modalDynamicIndex}.${item.jsonKey}`,
                )
              } else {
                value = dynamicData
              }
            } else {
              if (item.jsonKey) {
                let dynamicData = objectPath.get(
                  jsonForm.formData,
                  `${systemKey}.${modalDynamicIndex}`,
                )
                value = objectPath.get(dynamicData, item.jsonKey)
              } else {
                let dynamicData = objectPath.get(jsonForm.formData, systemKey)
                value = dynamicData
              }
            }
          } else if (item.systemType === 'datasource') {
            value = objectPath.get(datasourceValue, systemKey)
          } else if (item.systemType === 'formData') {
            let form = allFormGroup.find(({ key }) => key === systemKey)
            value = setRequestFormData(
              form,
              {},
              {
                datasourceValue,
                formData: jsonForm.formData,
                allParams,
                jsonForm,
              },
            )
          } else if (item.systemType === 'table') {
            value = objectPath.get(
              designerData,
              `${systemKey}.${item.fullPropKey}`,
            )
            objectPath.set(isUiChanged, '@rowEdit', value)
            if (item.selectedRow) {
              objectPath.set(isUiChanged, ['selectedRow', item.propKey], value)
            }
          } else if (item.systemType === 'replaceRow') {
          } else if (item.systemType === 'condition') {
            value = 1
          } else if (item.propType === 'system') {
          } else if (item.systemType === 'custom') {
            value = item.systemValue
          } else if (item.systemType === 'tableResponse') {
            let tableKey = item.systemKey
            let tableUi = getCurrentUi(
              tableKey,
              jsonForm.schema,
              jsonForm.uischema,
            )
            if (tableUi?.loadData?.method === 'GET') {
              let action = tableUi?.loadData?.get
              let dataKey = action.data
              let requestUrl = getApi(
                action,
                {
                  designContext,
                },
                'Modal',
              )
              let response = await httpClient
                .get(requestUrl)
                .then(({ data }) => data)
                .catch(() => [])
              if (!isActive) return
              value = dataKey ? objectPath.get(response, dataKey) : response
            } else {
              value = objectPath.get(jsonForm.formData, item.systemKey)
            }
          } else if (item.propReceive && item.systemType === 'input') {
            let ui = getCurrentUi(
              item.systemKey,
              jsonForm.schema,
              jsonForm.uischema,
            )
            if (item.systemKey === ui.key) {
              value =
                objectPath.get(jsonForm.formData, item.systemKey) ||
                objectPath.get(jsonForm.formData, ui.name)
            } else {
              value = objectPath.get(jsonForm.formData, item.systemKey)
            }
          } else if (item.systemType === 'apiResponse') {
            value = objectPath.get(
              jsonForm.formData,
              `@response.${item.systemKey}`,
            )
          } else if (item.systemType === 'tableWaitUpsert') {
            let isWaitUpsert = objectPath.get(isUiChanged, 'isWaitUpsert')
            value = isWaitUpsert?.rowData
          } else if (item.systemType === 'tableConfirmUpsert') {
            let isWaitUpsert = objectPath.get(isUiChanged, 'isWaitUpsert')
            value = isWaitUpsert?.table
          } else {
            value =
              objectPath.get(designerData, item.fullPropKey) ||
              objectPath.get(jsonForm.formData, item.fullPropKey)
          }
          if (
            item.propType === 'datasource' ||
            item.systemType === 'datasource'
          ) {
            objectPath.set(
              datasourceValue,
              `receiveProps.${item.fullPropKey}`,
              value,
            )
          }
          objectPath.set(systemData, item.fullPropKey, value)
          return item
        })

        if (isModalCondition) {
          objectPath.set(designJsonForm, 'designerPropsData.modal', uiModalCode)
        } else {
          objectPath.set(designJsonForm, 'designerPropsData.modal', modalCode)
        }
        objectPath.set(designJsonForm, 'designerPropsData.receive', receiveProps)
        objectPath.set(designJsonForm, 'designerPropsData.data', systemData)

        objectPath.set(modal, 'ui.systemData', systemData)
        objectPath.set(modal, 'ui.jsonForm', designJsonForm)
        objectPath.set(modal, 'ui.receiveProps', receiveProps)
        objectPath.set(modal, 'ui.datasourceValue', datasourceValue)
        setModalComponent(componentKey, designJsonForm, true)
        setModal(modal)
        setIsUiChanged(isUiChanged)
        console.log('modal designer', {
          isUiChanged,
          receiveProps,
          systemData,
          data: designJsonForm.designerPropsData.data,
          modal: designJsonForm.designerPropsData.modal,
          isOpenModal,
          openModal,
          modalKey: modalKey,
          isModalCondition,
          modalCode,
          uiModalCode,
          ui,
          modalAction,
          formData: jsonForm.formData,
          datasourceValue: datasourceValue,
          jsonForm: jsonForm,
          designerPropsData: designerPropsData,
        })

        if (ui.ui) {
          objectPath.del(ui, 'ui')
        }
      } else {
        setModal({})
      }
      onTriggerModal({ modalKey, designContext, isOpening: true })
    }
    loadModal()
    return () => {
      isActive = false
    }
  }, [isOpenModal])

  const patientAssessmentId = useMemo(() => {
    let assessmentKey = objectPath.get(modalAction, 'assessment.id')
    let assessmentLayout = objectPath.get(modalAction, 'assessment.layout')
    let patientAssessmentId = null
    if (!assessmentKey) return patientAssessmentId
    if (assessmentLayout === 'urlParam') {
      patientAssessmentId = objectPath.get(allParams, assessmentKey)
    } else {
      patientAssessmentId =
        objectPath.get(jsonForm.formData, assessmentKey) || null
    }
    return patientAssessmentId
  }, [isOpenModal])

  if (!isOpenModal || !isOpening) return <></>

  if (modalSize === 'fullscreen') {
    return (
      <FullSizeModal
        {...props}
        isOpenModal={isOpenModal}
        closeExternalModal={closeExternalModal}
      >
        {modalType === 'assessment' ? (
          <PatientAssessment
            form={{
              code: modalAction.assessmentCode,
              name: modalAction.assessmentName,
              patientAssessmentId: patientAssessmentId,
            }}
            modal={modal}
            isOpenModal={isOpenModal}
            componentKey={componentKey}
            designerPropsData={designerPropsData}
            closeExternalModal={closeExternalModal}
            onCancelAssessment={onCancelAssessment}
          />
        ) : (
          <Component
            uischema={modal}
            action={modalAction}
            isOpenModal={isOpenModal}
            modalCode={modalCode}
            closeExternalModal={closeExternalModal}
            onRefreshTable={onRefreshTable}
            modalDynamicIndex={modalDynamicIndex}
            isModalCondition={isModalCondition}
          />
        )}
      </FullSizeModal>
    )
  }

  return (
    <NormalModal
      {...props}
      isOpenModal={isOpenModal}
      closeExternalModal={closeExternalModal}
    >
      {modalType === 'assessment' ? (
        <PatientAssessment
          form={{
            code: modalAction.assessmentCode,
            name: modalAction.assessmentName,
            patientAssessmentId: patientAssessmentId,
          }}
          modal={modal}
          isOpenModal={isOpenModal}
          componentKey={componentKey}
          designerPropsData={designerPropsData}
          closeExternalModal={closeExternalModal}
          onCancelAssessment={onCancelAssessment}
        />
      ) : (
        <Component
          uischema={modal}
          action={modalAction}
          isOpenModal={isOpenModal}
          modalCode={modalCode}
          modalId={modalId}
          closeExternalModal={closeExternalModal}
          onRefreshTable={onRefreshTable}
          modalDynamicIndex={modalDynamicIndex}
          isModalCondition={isModalCondition}
        />
      )}
    </NormalModal>
  )
}

export default ModalButton
